import { AddUnityFormModalContext } from "@/contexts"
import { useContext } from "react"

export const useAddUnityFormModalContext = () => {
  const context = useContext(AddUnityFormModalContext)

  if (!context) throw new Error('useAddUnityFormModalContext have to be wrapped by AddUnityFormModalContextProvider')

  return context
}